import { Component, OnInit, ɵConsole } from '@angular/core';
import { NgbDateStruct, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { OmsServiceService } from '../services/oms-service.service';
import { Router, ActivatedRoute } from '@angular/router';
import { SharedService } from '../../../../tools/src/lib/shared/shared.service';
import { ConstantsService } from '../services/constants.service';
import { FormGroup, FormControl, FormsModule, Validators } from '@angular/forms';
//import * as data from './data.';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from "ngx-spinner";
import { NgbDate, NgbCalendar, NgbDateParserFormatter, NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { configurton } from '../../assets/data/configuration';
import { AddUsersComponent } from './add-users/add-users.component';
import { DatePipe, JsonPipe } from '@angular/common';

@Component({
  selector: 'app-ucd-users',
  templateUrl: './ucd-users.component.html',
  styleUrls: ['./ucd-users.component.scss']
})
export class UcdUsersComponent implements OnInit {
reimbursRequest = {};
  reimbursListRes = [];
  page = 1;
  pageSize = 20;
  collectionSize = 0;
  datacount = 0;
  totalRecords: Number = 0;
  bsRangeValue: Date[];
  maxDate = new Date();
  currentDate = new Date();
  searchForm: FormGroup;
  selectedFromDate: any;
  selectedToDate: any;
  searchFormRequest = {};
  reimbursementStatusList: [];

  constructor(
    private omsServiceService: OmsServiceService,
    private _router: Router,
    private sharedService: SharedService,
    private _activatedRoute: ActivatedRoute,
    private constantsService: ConstantsService,
    private modalService: NgbModal,
    private SpinnerService: NgxSpinnerService,
    private calendar: NgbCalendar,
    public formatter: NgbDateParserFormatter,
  ) { }

  ngOnInit(): void {

  }


  redirectAddUser() {

    const modalRef = this.modalService.open(AddUsersComponent, { windowClass: 'commonStyleModals modalWidth50p' });
    const closeModelRef = modalRef.result.then(
      (res) => {

      }
    );
    // modalRef.componentInstance.order_id = transactionId;
    // modalRef.componentInstance.claim_id = claimId;
  }




}
